// src/pages/AboutPage.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";

function AboutPage() {
  const navigate = useNavigate();
  return (
    <Container className="mt-5">
      <h1>About Prayers In Silence</h1>
      <p>
        This app was created for hearts that long to pray but don’t always know
        how— for those who search for words in moments of need, or whose voices
        are quieted by circumstance. Whether held back by uncertainty, emotion,
        or silence itself, you are not alone. Prayers in Silence offers gentle,
        guiding words to help you find comfort, strength, and sacred connection—
        even when the only sound is the stillness within.
        <br />
        <br />
        Each prayer is simple, heartfelt, and designed to offer peace and
        strength in silence.
        <br />
        <br />
        Whether you're at work, in a hospital bed, in a tough emotional space,
        or just need a quiet moment of reflection, this app is here to support
        your silent connection with God.
        <br />
        <br />
        <strong>Inspiration:</strong>
        <br />
        After walking through three personally challenging years, this app was
        born from a place of healing and rediscovery. While collaborating on
        another project—
        <a
          href="https://www.abibleadventure.com"
          target="_blank"
          rel="noopener noreferrer"
          className="custom-link"
        >
          abibleadventure.com
        </a>
        —with a colleague in software development, I was reminded of the quiet
        strength and clarity found in honest, heartfelt prayer. One day, the
        idea for *Prayers in Silence* came to me unexpectedly, and I felt called
        to build it, but as a gift to anyone who may not
        know how to pray, or can’t find the words. My hope is that it serves
        someone out there who just needs a little peace and a whisper of faith.
        Rejoice!
      </p>
      <div
        className="glass-button bg-transparent border-0 w-25 text-center mx-auto d-block"
        onClick={() => navigate("/")}
        title="Back to Home"
      >
        🏠
      </div>
    </Container>
  );
}

export default AboutPage;
